import { Route, useNavigate } from "@tanstack/react-router";
//import { rootRoute } from "../../App"
import { MainAppRoute } from "@/rootRoutes/MainApp";
import { manageAccessToken } from "@/utils/Auth/Session";
import { AuthenticateUserResp } from "../Authentication/AuthUtils/Login";
import HeaderComponent from "@/components/Header/Header";
import { HiringCampaign } from "openapi/api/model";
import JobRequirementForm from "../HiringCampaignConfig2.0/components/JobRequirementForm";
import { useGetUserHiringresource, postHiringcampaigns } from '../../../openapi/api/endpoints/default/default';
import { toast } from "sonner";
import { queryClient } from "@/App";
import { Toaster } from "@/components/ui/sonner";
import { useState } from "react";

const NewCampaign = () => {
  const navigate=useNavigate({from:'/'})
  const {data} = useGetUserHiringresource()
  const licenseId=data?.licenseId
  const [disableSubmit,setDisableSubmit]=useState(false)



  const createHiringCampaign=async (requirements:HiringCampaign)=>{
    try{
      setDisableSubmit(true)
      const hiringCampaign:HiringCampaign={
        ...requirements,
        licenseId:licenseId??''
      }
      await postHiringcampaigns(hiringCampaign)
      queryClient.invalidateQueries({ queryKey: ['/hiringcampaigns/search'] })
      toast.success("Submitted!",{
        description: 'Hiring Campaign create successfully',
        action: {
            label: "Dismiss",
            onClick: () => {},
        },
        style: {
            background: '#a3e635'
        }
      })
      setTimeout(()=>navigate({to:'/allCampaigns'}),2000)
    }catch(err){
      console.log({CreateHiringCampaignErr:err})
      toast.error("Failed to create hiring campaign!",{
        description: "Please try again later",
        action: {
          label: "Dismiss",
          onClick: () => {},
        },
        style: {
          background: '#dc2626'
        }
      })
      setDisableSubmit(false)
    }
  }



  /*  if(isSuccess){
    console.log('user data is',data?.sub)
  } */

  return (
    <div className="flex flex-col p-4 bg-gray-100 min-h-screen">
      <HeaderComponent title="New Campaign"/>
      <div className="container mx-auto p-4 ">
        <JobRequirementForm onSubmitCallBack={createHiringCampaign} disableSubmit={disableSubmit}/>
      <Toaster/>
      </div>
    </div>
    )
};

const NewCampaignRoute = new Route({
  getParentRoute: () => MainAppRoute,
  path: "/newCampaign",
  component: NewCampaign,
  beforeLoad: async ({ context: { auth, queryClient } }) => {
    const session = await manageAccessToken({ AuthPayload: auth as AuthenticateUserResp });
    if (!session) {
      //no token means that token is still good
      return;
    }
    const newAuthPayload = {
      ...auth,
      session,
    } as AuthenticateUserResp;
    queryClient.setQueryData(["Auth"], newAuthPayload);
    return {
      auth: newAuthPayload,
    };
  },
});
export default NewCampaignRoute;
